var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.395,
    height: 36.395,
    viewBox: "0 0 41.395 36.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79266a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_36676",
    "data-name": "Group 36676",
    transform: "translate(-98.605 -340.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36671",
    "data-name": "Group 36671",
    transform: "translate(10539.878 -14377.895)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notice_board",
    "data-name": "notice board",
    transform: "translate(-10441.272 14718.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6012",
    "data-name": "Rectangle 6012",
    width: 24.348,
    height: 12.174,
    transform: "translate(6.006 19.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57587",
    "data-name": "Path 57587",
    d: "M36.017,14.2H32.635L20.181,3.313a2.192,2.192,0,0,0,.3-1.092,2.219,2.219,0,1,0-4.439,0,2.191,2.191,0,0,0,.3,1.092L3.892,14.2H.51a.439.439,0,0,0-.444.444v21.3A.44.44,0,0,0,.51,36.4H36.017a.439.439,0,0,0,.444-.444v-21.3a.44.44,0,0,0-.444-.444ZM18.263.89a1.327,1.327,0,0,1,1,2.2V3.1a1.348,1.348,0,0,1-1,.453,1.329,1.329,0,0,1-.994-.453V3.091H17.26a1.327,1.327,0,0,1,1-2.2ZM28.915,29.3H7.611a.444.444,0,1,1,0-.887h21.3a.444.444,0,1,1,0,.887Zm0-7.1H7.611a.444.444,0,1,1,0-.887h21.3a.444.444,0,1,1,0,.887ZM5.241,14.2,16.923,3.979a2.177,2.177,0,0,0,2.681,0L31.285,14.2Z",
    transform: "translate(-0.066 -0.002)",
    fill: "#869b34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57588",
    "data-name": "Path 57588",
    d: "M192.573,186.67h1.567a.44.44,0,0,1,.444.444v21.3a.439.439,0,0,1-.444.444H171.211a47,47,0,0,0,9.114-7.1h6.713a.444.444,0,1,0,0-.887H181.22a82.923,82.923,0,0,0,5.534-6.214h.284a.444.444,0,0,0,.318-.753C189.341,191.4,191.1,188.914,192.573,186.67Z",
    transform: "translate(-158.189 -172.467)",
    fill: "#c7e64b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57589",
    "data-name": "Path 57589",
    d: "M32.635,92.963h3.382a.44.44,0,0,1,.444.444v2.726a35,35,0,0,1-9.081,11.033H7.611a.444.444,0,1,0,0,.887H26.294a66.967,66.967,0,0,1-11.225,7.1H.51a.439.439,0,0,1-.444-.444v-5.96a40.068,40.068,0,0,0,12.268-7.8H28.915a.444.444,0,1,0,0-.887H13.277a50.2,50.2,0,0,0,6.059-7.1h11.95L23.42,86.078q.205-.424.391-.832Z",
    transform: "translate(-0.066 -78.76)",
    fill: "#abc73e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7337",
    "data-name": "Ellipse 7337",
    cx: 1.141,
    cy: 1.141,
    rx: 1.141,
    ry: 1.141,
    transform: "translate(17.038 1.065)",
    fill: "#9b3288"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_36672",
    "data-name": "Group 36672",
    transform: "translate(125.974 346.789)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_448",
    "data-name": "Ellipse 448",
    cx: 4.567,
    cy: 4.567,
    rx: 4.567,
    ry: 4.567,
    transform: "translate(2.448 2.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-clock",
    "data-name": "Icon awesome-clock",
    d: "M7.576.563a7.013,7.013,0,1,0,7.013,7.013A7.012,7.012,0,0,0,7.576.563Z",
    transform: "translate(-0.563 -0.562)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49021",
    "data-name": "Path 49021",
    d: "M26.617,16.788a.857.857,0,0,1-.612-.257l-1.252-1.268a.884.884,0,0,1,0-1.239.857.857,0,0,1,1.223,0l.641.649,1.893-1.917a.857.857,0,0,1,1.223,0,.884.884,0,0,1,0,1.239l-2.5,2.536A.857.857,0,0,1,26.617,16.788Z",
    transform: "translate(-20.228 -7.631)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeboardIcon);
export default __webpack_public_path__ + "static/media/Noticeboard_icon.489cf1e99874cf7f696794ca0d5305a2.svg";
export { ForwardRef as ReactComponent };